import { supportConstants } from '../constants'

const initialState = {
    sending: false,
    status: undefined,
    data: {
        name: '',
        email: '',
        message: '',
    },
}

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case supportConstants.REQUEST: {
            return {
                ...state,
                sending: true,
            }
        }
        case supportConstants.RESET: {
            return {
                ...initialState,
            }
        }
        case supportConstants.RESET_STATUS: {
            return {
                ...state,
                status: undefined,
            }
        }
        case supportConstants.SUCCESS: {
            // reset form on success
            return {
                ...state,
                sending: false,
                status: 'success',
                data: {
                    ...initialState.data,
                },
            }
        }
        case supportConstants.FAILURE: {
            return {
                ...state,
                sending: false,
                status: 'failure',
            }
        }
        case supportConstants.CHANGE_VALUE:
            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: action.value,
                },
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/connectors/redux/reducers/feedback.js